import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'Track';
const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $get = ActionCreator.Async(MODULE, 'Show', (payload) => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/tracking`, payload)
      .then((response) => {
        dispatch($get.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $getImage = ActionCreator.Async(MODULE, 'get', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($getImage.OPERATION));

    return await Rest.GET(`${API_URL}/tracking/${id}/image`, payload)
      .then((response) => {
        dispatch($getImage.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getImage.OPERATION)));
  };
});

export const $getMaps = ActionCreator.Async(MODULE, 'getMaps', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($getMaps.OPERATION));

    return await Rest.GET(`${API_URL}/fleet/maps/${id}`, payload)
      .then((response) => {
        dispatch($getMaps.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getMaps.OPERATION)));
  };
});